import * as angular from "angular";

export class SignedOutController {
  public static $inject: any[] = [];

  constructor() {}
}

angular
  .module("PortalApp")
  .controller("Rhinestone.SignedOutController", SignedOutController);
